/**
 * @param message Message for the native web view.
 */
export const postNativeMessage = (message: string): void => {
  console.log('postNativeMessage:', message)
  if (typeof message !== 'string') {
    console.log('ERROR 1')
    throw new Error('Native message must be a string!')
  }

  if (typeof window.ReactNativeWebView?.postMessage !== 'function') {
    console.log('ERROR 2')
    return
  }

  console.log('Posting native message:', message)
  window.ReactNativeWebView.postMessage(message)
}

type ServiceKey = 'ukkopro' | 'oy' | 'tlp' | 'ky'

interface StoreLinks {
  ANDROID: Record<ServiceKey, string>
  IOS: Record<ServiceKey, string>
}

export const STORE_LINKS: StoreLinks = {
  ANDROID: {
    ukkopro: 'https://play.google.com/store/apps/details?id=com.spl.ukkopro',
    oy: 'https://play.google.com/store/apps/details?id=com.spl.oy',
    tlp: 'https://play.google.com/store/apps/details?id=com.spl.kyy',
    ky: 'https://play.google.com/store/apps/details?id=com.spl.ky'
  },
  IOS: {
    ukkopro: 'https://apps.apple.com/fi/app/ukko-entrepreneur-tmi/id1641658524',
    oy: 'https://apps.apple.com/fi/app/ukko-entrepreneur-ltd/id6740853613',
    tlp: 'https://apps.apple.com/fi/app/ukko-light-entrepreneur/id6599848558',
    ky: 'https://apps.apple.com/fi/app/ukko-light-entrepreneurship/id6471959878'
  }
}

export default {
  postNativeMessage
}
